var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-btn-container"},[_c('v-switch',{attrs:{"label":this.buttonLabel,"color":"blue"},on:{"click":function($event){return _vm.toggleLayer()}},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }